<template>
    <transition name="fm-modal">
        <div class="fm-modal" ref="fmModal" v-on:click="hideModal">
            <div class="modal-dialog"
                 role="document"
                 v-bind:class="modalSize"
                 v-on:click.stop>
                <component v-bind:is="modalName"/>
            </div>
        </div>
    </transition>
</template>

<script>
import NewFile from './views/NewFile.vue';
import NewWordFile from './views/NewWordFile.vue';
import NewExcelFile from './views/NewExcelFile.vue';
import NewPresentationFile from './views/NewPresentationFile.vue';
import NewFolder from './views/NewFolder.vue';
import Upload from './views/Upload.vue';
import Share from './views/Share.vue';
import ModifyFile from './views/ModifyFile.vue';
import ModifyDocumentType from './views/ModifyDocumentType.vue';
import Delete from './views/Delete.vue';
import Clipboard from './views/Clipboard.vue';
import Status from './views/Status.vue';
import Rename from './views/Rename.vue';
import Properties from './views/Properties.vue';
import Preview from './views/Preview.vue';
import DocumentPreview from './views/DocumentPreview';
import FormPreview from './views/FormPreview';
import TextEdit from './views/TextEdit.vue';
import AudioPlayer from './views/AudioPlayer.vue';
import VideoPlayer from './views/VideoPlayer.vue';
import Zip from './views/Zip.vue';
import Unzip from './views/Unzip.vue';
import About from './views/About.vue';
import Workflow from './views/Workflow.vue';

export default {
  name: 'Modal',
  components: {
    NewFile,
    NewWordFile,
    NewExcelFile,
    NewPresentationFile,
    NewFolder,
    Upload,
    Share,
    ModifyFile,
    ModifyDocumentType,
    Delete,
    Clipboard,
    Status,
    Rename,
    Properties,
    Preview,
    DocumentPreview,
    TextEdit,
    AudioPlayer,
    VideoPlayer,
    Zip,
    Unzip,
    About,
    Workflow,
    FormPreview
  },
  mounted() {
    // set height
    this.$store.commit('modal/setModalBlockHeight', this.$refs.fmModal.offsetHeight);
  },
  computed: {
    /**
     * Selected modal name
     * @returns {null|*}
     */
    modalName() {
      return this.$store.state.modal.modalName;
    },

    /**
     * Modal size style
     * @returns {{'modal-lg': boolean, 'modal-sm': boolean}}
     */
    modalSize() {
      return {
        'modal-xl': this.modalName === 'Preview' || this.modalName === 'TextEdit' ||
        this.modalName === 'DocumentPreview' || this.modalName === 'GlobalDocumentPreview',
        'modal-lg': this.modalName === 'VideoPlayer' || this.modalName === 'Upload'
          || this.modalName === 'FormPreview',
        'modal-md': this.modalName === 'Properties',
        'modal-sm': false,
      };
    },
  },
  methods: {
    /**
     * Hide modal window
     */
    hideModal() {
      this.$store.commit('modal/clearModal');
    },
  },
};
</script>

<style lang="scss">

    .fm-modal {
        position: absolute;
        z-index: 10000;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.459);
        display: block;
        transition: opacity .4s ease;
        overflow: auto;

        .modal-xl {
            max-width: 100%;
            height: 100% !important;
            max-width: none;
            margin: 0;
            border-radius: 0;
            overflow: hidden;
        }
    }

    .fm-modal-enter-active, .fm-modal-leave-active {
        transition: opacity .5s;
    }
    .fm-modal-enter, .fm-modal-leave-to {
        opacity: 0;
    }
</style>
